import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { GroupService } from '../services/groups.service';
import { inject } from '@angular/core';
import { catchError, Observable, of } from 'rxjs';
import { Group } from '@core/auth/interfaces/group';

export const groupResolver = (
	route: ActivatedRouteSnapshot
): Observable<Group> => {
	const groupSvc = inject(GroupService);
	const groupId = route.paramMap.get('groupId');
	return groupId && groupId !== 'add'
		? groupSvc.find(groupId).pipe(catchError(() => of(null)))
		: of(null);
};
